import Vue from "vue";
import { onMounted, onUnmounted, Ref, ref } from "@vue/composition-api";

export const useTextSelection = (container: Ref<Vue | HTMLElement | null>) => {
  const selected = ref<string>("");
  const range = ref<Range | null>(null);

  const reset = () => {
    selected.value = "";
    range.value = null;
  };

  const listener = () => {
    const selection = window.getSelection();

    if (
      container.value === null ||
      selection === null ||
      selection.rangeCount === 0 ||
      !("$el" in container.value
        ? container.value.$el
        : container.value
      ).contains(selection.getRangeAt(0).commonAncestorContainer)
    ) {
      return reset();
    }

    selected.value = selection.toString().trim();
    range.value = selection.getRangeAt(0);
  };

  onMounted(() => {
    document.addEventListener("selectionchange", listener);
  });

  onUnmounted(() => {
    document.removeEventListener("selectionchange", listener);
  });

  return { selected, range, reset };
};
